import Turnstile from 'react-turnstile';
import { track } from 'src/analytics/Analytics';
import EventNames from 'src/analytics/EventNames';
import { PageType } from 'src/analytics/EventProps';
import { env } from 'src/env.mjs';

type CaptchaProps = {
    onVerify: (token: string) => void;
    pageType: PageType;
};

function Captcha({ onVerify, pageType }: CaptchaProps) {
    return (
        <Turnstile
            theme="light"
            size="flexible"
            refreshExpired="auto"
            sitekey={env.NEXT_PUBLIC_TURNSTILE_SITE_KEY}
            onVerify={onVerify}
            onError={(error) => {
                track(EventNames.ERROR_TRIGGERED, {
                    error_type: 'captcha_verification_failed',
                    error_message: `Captcha Verification failed with error code: ${error.toString()}`,
                    page_type: pageType,
                });
            }}
        />
    );
}

export default Captcha;
